export const TestIds = {
  NewPayrunApproverButton: 'new-payrun-approver-button',
  PayrunTypeId: 'pay-run-type',
  PayScheduleId: 'pay-schedule',
  SelectedUsers: 'selected-users',
};
